// Version: 1.1
// Modified By: Chau Yun Pang
// Modified Date: 4 May 2018
// Change Log: Add auto load jQuery script if the page without jQuery library load
// Modified Date: 14 May 2018
// Change Log: Change 最後今天 Display Logic to Mon 20:00 to Wed 12:00
// MOdified Date: 31 May 2018
// Change Log: Fix the Delivery Date Display incorrect if the day is equal to 31 issue
// Modified Date: 13 Mar 2021
// Change Log: Add Override Cut Off Date Feature
// Modified Date: 2 Jun 2022
// Change Log: Fix Set the Override Cut Off Date to Tomorrow cannot show the message correctly issue
// Modified Date: 2 Dec 2022
// Change Log: Change 最後今天 Add Display Logic with Thu 20:00 to Sat 12:00

var loadScript = function(url, callback){

 var script = document.createElement("script");
  script.type = "text/javascript";

  // If the browser is Internet Explorer.
  if (script.readyState){ 
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" || script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
  // For any other browser.
  } else {
    script.onload = function(){
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);  
  
};

var preOrderNotificationJavaScript = function($){
  
  var str = $(document).attr('title');
  
  const regex = /預訂貨品， ?(\d+) ?月 ?(\d+) ?日送出/gm;
  var m;
  
  if (m = regex.exec(str)) {
    
    if (m.length == 3) {
      
      var deliveryMonth = parseInt(m[1]);
      
      var deliveryDay = parseInt(m[2]);
      
      var today = new Date();
      
      var dayMonth = today.getMonth();
      var dayYear = today.getFullYear();
      
      var dayOfWeek = today.getDay();
      
      var cutOffDate = new Date();
      var cutOffPrevDate = new Date();
      var cutOffNextDate = new Date();
      var cutOffDay = 2; // 0 (Sun) - 6 (Sat), 

      if(typeof(overrideCutOrderDate ) !== "undefined") {
        cutOffDate = new Date(overrideCutOrderDate);
        cutOffPrevDate.setDate(cutOffDate.getDate() - 1);
        cutOffNextDate.setDate(cutOffDate.getDate() + 1);
      }
      else {
        if (dayOfWeek == cutOffDay-1) {
          // Monday
          // console.log('Monday');
          cutOffDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate(today.getDate());
          cutOffNextDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffNextDate.setDate( (cutOffNextDate.getDate() + 1) );            
        }
        else if (dayOfWeek == cutOffDay) {
          // Tuesday
          // console.log('Tuesday');
          cutOffDate.setDate(today.getDate());
          cutOffPrevDate.setDate(today.getDate());
          cutOffNextDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffNextDate.setDate( (cutOffNextDate.getDate() + 1) );            
        }else if (dayOfWeek == cutOffDay+1) {
          // Wednesday
          // console.log('Wednesday');
          cutOffDate.setDate(today.getDate() + 2);
          cutOffPrevDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate( (cutOffPrevDate.getDate() - 1) );
          cutOffNextDate.setDate(today.getDate());            
        }
        else if (dayOfWeek == cutOffDay+2) {
          // Thursday
          // console.log('Thursday');
          cutOffDate.setDate(today.getDate() + 1);
          cutOffPrevDate.setDate(today.getDate());
          cutOffNextDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffNextDate.setDate( (cutOffNextDate.getDate() + 1) );            
        }
        else if (dayOfWeek == cutOffDay+3) {
          // Friday
          // console.log('Friday');
          cutOffDate.setDate(today.getDate());
          cutOffPrevDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate( (cutOffPrevDate.getDate() - 1) );
          cutOffNextDate.setDate(today.getDate());            
        }
        else if (dayOfWeek == cutOffDay+4) {
          // Saturday
          // console.log('Saturday');
          cutOffDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate( (cutOffPrevDate.getDate() - 1) );
          cutOffNextDate.setDate(today.getDate());            
        }
        else if (dayOfWeek != cutOffDay) {
          // Sunday
          // console.log('Sunday');
          cutOffDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffPrevDate.setDate( (cutOffPrevDate.getDate() - 1) );
          cutOffNextDate.setDate(today.getDate() + (dayOfWeek < cutOffDay ? cutOffDay - dayOfWeek : 7 - (dayOfWeek - cutOffDay)));
          cutOffNextDate.setDate( (cutOffNextDate.getDate() + 1) );            
        }
      }      
      
      var deliveryDate = new Date();
      
      if (dayMonth > deliveryMonth) {
        deliveryDate.setFullYear(dayYear + 1);
      }
      
      deliveryDate.setDate(deliveryDay);
      deliveryDate.setMonth((deliveryMonth - 1));
      
      var validCutOffDate = cutOffDate < deliveryDate;
      
      const preOrderRegex = /(\d+) ?月 ?(\d+) ?日截單，貨品於 ?(\d+) ?月 ?(\d+) ?日送出/gm;
      const preOrderRegex2 = /最後今天截單，貨品於 ?(\d+) ?月 ?(\d+) ?日送出/gm;
      
      var description = $('.product-single__description').html();
            
      var preOrderMatch = preOrderRegex.test(description);
      var preOrderMatch2 = preOrderRegex2.test(description);
            
      if (!preOrderMatch && !preOrderMatch2) {
        const preOrderNotificationLabel = '<h3><span style="color: #ff0000;">*****{0}截單，貨品於{1}送出*****</span></h3><h3><span style="color: #ff0000;"></span><span>*****如訂單內有其他貨品，會等齊貨一次過出貨*****</span></h3>';
        
        var isLastDay = (cutOffDate.getFullYear() == today.getFullYear() && cutOffDate.getMonth() == today.getMonth() && cutOffDate.getDate() == today.getDate()) || (cutOffPrevDate.getFullYear() == today.getFullYear() && cutOffPrevDate.getMonth() == today.getMonth() && cutOffPrevDate.getDate() == today.getDate() && today.getHours() >= 20 && typeof(overrideCutOrderDate ) === "undefined") || (cutOffNextDate.getFullYear() == today.getFullYear() && cutOffNextDate.getMonth() == today.getMonth() && cutOffNextDate.getDate() == today.getDate() && today.getHours() < 12);
        
        var preOrderNotificationOutput = preOrderNotificationLabel.replace('{0}', (isLastDay ? '最後今天' : (cutOffDate.getMonth() + 1) + '月' + cutOffDate.getDate() + '日')).replace('{1}', deliveryMonth + '月' + deliveryDay + '日');
        
        $('.preordernotification-container').html(preOrderNotificationOutput);
      }
    }
  }

};


if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    preOrderNotificationJavaScript(jQuery191);
  });
} else {
  preOrderNotificationJavaScript(jQuery);
}
